// Shared visual metadata for staff document/onboarding template types.
// Port of platform-app components/team/templateTypeMeta.ts, restyled with
// light tints that read on the RUBY light chrome (white cards, stone borders).
// Keep in sync with DocumentTemplateType ('upload' | 'acknowledgment' | 'form' | 'sheet' | 'fillable_doc').

export const TEMPLATE_TYPE_LABEL: Record<string, string> = {
  upload: 'Upload', acknowledgment: 'Acknowledgment', form: 'Web Form', sheet: 'Sheet', fillable_doc: 'Fillable Doc',
};

export const TEMPLATE_TYPE_META: Record<string, { icon: string; badge: string; tile: string }> = {
  acknowledgment: { icon: '✍️', badge: 'bg-rose-100 text-rose-700', tile: 'bg-rose-100 text-rose-700' },
  fillable_doc:   { icon: '📄', badge: 'bg-amber-100 text-amber-700',   tile: 'bg-amber-100 text-amber-700' },
  form:           { icon: '📝', badge: 'bg-blue-100 text-blue-700',     tile: 'bg-blue-100 text-blue-700' },
  sheet:          { icon: '📋', badge: 'bg-teal-100 text-teal-700',     tile: 'bg-teal-100 text-teal-700' },
  upload:         { icon: '📎', badge: 'bg-stone-200 text-stone-700',   tile: 'bg-stone-100 text-stone-700' },
};

export const templateMeta = (t?: string) => TEMPLATE_TYPE_META[t || 'upload'] || TEMPLATE_TYPE_META.upload;
export const templateTypeLabel = (t?: string) => TEMPLATE_TYPE_LABEL[t || 'upload'] || 'Upload';
